function Mapper () {
  function supplier (data) {
    return {
      id: data.id_token,
      companyOverview: {
        name: data.company_overview.company_name,
        rdStaffCount: data.company_overview.RD_staff_count,
        chineseName: data.company_overview.chinese_company_name || 'N/A',
        country: data.company_overview.country,
        description: data.company_overview.description || 'N/A',
        drsIframe: data.company_overview.drs_iframe,
        dunsRegistrationNumber: data.company_overview.duns_registration_number || 'N/A',
        logo: data.company_overview.logo,
        productionCapacity: data.company_overview.production_capacity,
        rating: data.company_overview.rating,
        totalAnnualRevenue: data.company_overview.total_annual_revenue,
        totalEmployees: data.company_overview.total_employees,
        yearEstablished: data.company_overview.year_established,
        supplierFactory: data.company_overview.supplier_factory.map( fac => {
          return {
            location: fac.location,
            size: fac.size,
            totalProductionLines: fac.total_production_lines
          }
        })
      },
      businessTypes: data.business_types,
      additionalInformation: {
        certificates: data.additional_information.certificates.map(certificate => {
          return {
            type: certificate.certificate_type,
            url: certificate.url
          }
        }),
        patents: data.additional_information.patents,
        paymentTerms: data.additional_information.payment_terms
      },
      mainMarkets: data.main_markets,
      mainProducts: data.main_products.map(item => product(item)),
      products: data.products.map(item => product(item)),
      productionCapability: data.production_capability
    }
  }

  function product (data) {
    return {
      id: data.id_token,
      slug: data.slug,
      name: data.product_name,
      category: data.category_name,
      images: data.images ? data.images.map(img => img.url) : null,
      price: data.price,
      stockInUsa: data.stock_in_usa,
      supplier: {
        id: data.supplier.supplier_id_token,
        name: data.supplier.company_name
      }
    }
  }

  return {
    supplier
  }
}

export default Mapper()
